import Core from './core-container';

export default Core;
